import './auto-close-handler-253c0ad4.js';
var UuidService = /** @class */ (function () {
    function UuidService() {
    }
    UuidService.v4 = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            /* tslint:disable:no-bitwise */
            var r = (Math.random() * 16) | 0;
            var v = c === 'x' ? r : (r & 0x3) | 0x8;
            /* tslint:enable:no-bitwise */
            return v.toString(16);
        });
    };
    return UuidService;
}());
var tooltip_OFFSET_X = 2;
var tooltip_OFFSET_Y = 2;
var MARGIN_PARENT_SIDE = 2;
var MARGIN_ARROW = 12;
var OFFSET_ARROW = 6;
var Position;
(function (Position) {
    Position["TOP"] = "top";
    Position["BOTTOM"] = "bottom";
    Position["LEFT"] = "left";
    Position["RIGHT"] = "right";
})(Position || (Position = {}));
var PositionHandler = /** @class */ (function () {
    function PositionHandler(tooltip, parentReference, boxContainer, position, delay) {
        if (position === void 0) { position = Position.TOP; }
        if (delay === void 0) { delay = 200; }
        this.tooltip = tooltip;
        this.parentReference = parentReference;
        this.boxContainer = boxContainer;
        this.position = position;
        this.delay = delay;
        this.tooltipArrow = null;
        this.parentReferenceRect = null;
        this.boxContainerRect = null;
        this.nextPositions = PositionHandler.getDefaultNextPositions();
        this.parentReferenceRect = this.parentReference.getBoundingClientRect();
        this.boxContainerRect = this.updateBoxContainerRect();
        this.tooltipArrow = this.tooltip.firstChild;
    }
    PositionHandler.getDefaultNextPositions = function () {
        return {
            top: [Position.BOTTOM, Position.LEFT, Position.RIGHT],
            bottom: [Position.TOP, Position.LEFT, Position.RIGHT],
            left: [Position.RIGHT, Position.TOP, Position.BOTTOM],
            right: [Position.LEFT, Position.TOP, Position.BOTTOM],
        };
    };
    PositionHandler.prototype.updateBoxContainerRect = function () {
        if (this.boxContainer instanceof Window) {
            this.boxContainerRect = {
                top: 0,
                left: 0,
                bottom: window.innerHeight,
                right: window.innerWidth,
                x: 0,
                y: 0,
                width: window.innerWidth,
                height: window.innerHeight,
            };
        }
        else {
            this.boxContainerRect = this.boxContainer.getBoundingClientRect();
        }
        return this.boxContainerRect;
    };
    PositionHandler.prototype.updatePosition = function () {
        var newPosition = null;
        var position = this.position;
        this.nextPositions = PositionHandler.getDefaultNextPositions();
        do {
            newPosition = this.getPosition(position);
            if (!newPosition) {
                position = this.getNextPosition();
            }
        } while (position && !newPosition);
        if (!newPosition) {
            throw new Error('Cannot find suitable position for the tooltip');
        }
        else {
            this.setArrowPosition(position);
            this.tooltip.style.left = newPosition.left + "px";
            this.tooltip.style.top = newPosition.top + "px";
        }
    };
    PositionHandler.prototype.onMouseEnter = function () {
        var _this = this;
        this.tooltip.style.opacity = '0';
        this.tooltipArrow.style.opacity = '0';
        this.mouseEnterTimeout = window.setTimeout(function () {
            _this.mouseEnterTimeout = null;
            _this.updatePosition();
            _this.tooltip.style.opacity = '1';
            _this.tooltipArrow.style.opacity = '1';
        }, this.delay);
    };
    PositionHandler.prototype.onMouseLeave = function () {
        clearTimeout(this.mouseEnterTimeout);
    };
    PositionHandler.prototype.setArrowPosition = function (position) {
        this.tooltip.style.left = '0';
        this.tooltip.style.top = '0';
        this.tooltipArrow.style.transform = 'rotate(0)';
        var tooltipArrowPosition = { left: 0, top: 0 };
        var tooltipArrowRect = this.tooltipArrow.getBoundingClientRect();
        switch (position) {
            case Position.TOP:
                tooltipArrowPosition.left =
                    this.parentReferenceRect.x + this.parentReference.clientWidth / 2 - tooltipArrowRect.width / 2;
                tooltipArrowPosition.top = this.parentReferenceRect.y - tooltipArrowRect.height - tooltip_OFFSET_Y;
                this.tooltipArrow.style.transform = 'rotate(180deg)';
                break;
            case Position.BOTTOM:
                tooltipArrowPosition.left =
                    this.parentReferenceRect.x + this.parentReference.clientWidth / 2 - tooltipArrowRect.width / 2;
                tooltipArrowPosition.top = this.parentReferenceRect.y + this.parentReference.clientHeight + tooltip_OFFSET_Y;
                break;
            case Position.LEFT:
                tooltipArrowPosition.left =
                    this.parentReferenceRect.x - (tooltipArrowRect.width + tooltip_OFFSET_X) + OFFSET_ARROW;
                tooltipArrowPosition.top =
                    this.parentReferenceRect.y + this.parentReference.clientHeight / 2 - tooltipArrowRect.height / 2;
                this.tooltipArrow.style.transform = 'rotate(90deg)';
                break;
            case Position.RIGHT:
                tooltipArrowPosition.left =
                    this.parentReferenceRect.x + this.parentReference.clientWidth + tooltip_OFFSET_X - OFFSET_ARROW;
                tooltipArrowPosition.top =
                    this.parentReferenceRect.y + this.parentReference.clientHeight / 2 - tooltipArrowRect.height / 2;
                this.tooltipArrow.style.transform = 'rotate(-90deg)';
                break;
            default:
                tooltipArrowPosition.left =
                    this.parentReferenceRect.x + this.parentReference.clientWidth / 2 - tooltipArrowRect.width / 2;
                tooltipArrowPosition.top = this.parentReferenceRect.y - tooltipArrowRect.height - tooltip_OFFSET_Y;
                this.tooltipArrow.style.transform = 'rotate(180deg)';
                break;
        }
        this.tooltipArrow.style.left = tooltipArrowPosition.left + "px";
        this.tooltipArrow.style.top = tooltipArrowPosition.top + "px";
    };
    PositionHandler.prototype.calculatePosition = function (position) {
        var tooltipPosition = { left: 0, top: 0 };
        this.parentReferenceRect = this.parentReference.getBoundingClientRect();
        this.tooltip.style.left = '0';
        this.tooltip.style.top = '0';
        switch (position) {
            case Position.TOP:
                tooltipPosition.left =
                    this.parentReferenceRect.x + this.parentReference.clientWidth / 2 - this.tooltip.clientWidth / 2;
                tooltipPosition.top = this.parentReferenceRect.y - this.tooltip.clientHeight - tooltip_OFFSET_Y - MARGIN_ARROW;
                break;
            case Position.BOTTOM:
                tooltipPosition.left =
                    this.parentReferenceRect.x + this.parentReference.clientWidth / 2 - this.tooltip.clientWidth / 2;
                tooltipPosition.top =
                    this.parentReferenceRect.y + this.parentReference.clientHeight + tooltip_OFFSET_Y + MARGIN_ARROW;
                break;
            case Position.LEFT:
                tooltipPosition.left =
                    this.parentReferenceRect.x - (this.tooltip.clientWidth + tooltip_OFFSET_X + MARGIN_ARROW);
                tooltipPosition.top =
                    this.parentReferenceRect.y + this.parentReference.clientHeight / 2 - this.tooltip.clientHeight / 2;
                break;
            case Position.RIGHT:
                tooltipPosition.left =
                    this.parentReferenceRect.x + this.parentReference.clientWidth + tooltip_OFFSET_X + MARGIN_ARROW;
                tooltipPosition.top =
                    this.parentReferenceRect.y + this.parentReference.clientHeight / 2 - this.tooltip.clientHeight / 2;
                break;
            default:
                tooltipPosition.left =
                    this.parentReferenceRect.x + this.parentReference.clientWidth / 2 - this.tooltip.clientWidth / 2;
                tooltipPosition.top = this.parentReferenceRect.y - this.tooltip.clientHeight - tooltip_OFFSET_Y - MARGIN_ARROW;
                break;
        }
        return tooltipPosition;
    };
    PositionHandler.prototype.getPosition = function (position) {
        var newPosition = this.calculatePosition(position);
        this.tooltip.style.left = newPosition.left + "px";
        this.tooltip.style.top = newPosition.top + "px";
        var tooltipBoundingRect = this.tooltip.getBoundingClientRect();
        this.boxContainerRect = this.updateBoxContainerRect();
        switch (position) {
            case Position.TOP:
                if (tooltipBoundingRect.top <= this.boxContainerRect.top) {
                    newPosition = null;
                }
                else {
                    newPosition = this.checkOutsideViewPortWidth(tooltipBoundingRect, newPosition);
                }
                break;
            case Position.BOTTOM:
                if (tooltipBoundingRect.bottom >= this.boxContainerRect.bottom) {
                    newPosition = null;
                }
                else {
                    newPosition = this.checkOutsideViewPortWidth(tooltipBoundingRect, newPosition);
                }
                break;
            case Position.LEFT:
                if (tooltipBoundingRect.left <= this.boxContainerRect.left) {
                    newPosition = null;
                }
                else {
                    newPosition = this.checkOutsideViewPortHeight(tooltipBoundingRect, newPosition);
                }
                break;
            case Position.RIGHT:
                if (tooltipBoundingRect.right >= this.boxContainerRect.right) {
                    newPosition = null;
                }
                else {
                    newPosition = this.checkOutsideViewPortHeight(tooltipBoundingRect, newPosition);
                }
                break;
        }
        return newPosition;
    };
    PositionHandler.prototype.getNextPosition = function () {
        var nextPos = null;
        if (this.nextPositions[this.position].length > 0) {
            nextPos = this.nextPositions[this.position][0];
            this.nextPositions[this.position].shift();
        }
        return nextPos;
    };
    PositionHandler.prototype.checkOutsideViewPortWidth = function (bouding, position) {
        if (bouding.left <= this.boxContainerRect.left) {
            position.left = position.left + (this.boxContainerRect.left - position.left) + MARGIN_PARENT_SIDE;
        }
        if (bouding.right >= this.boxContainerRect.right) {
            position.left = position.left - (bouding.right - this.boxContainerRect.right) - MARGIN_PARENT_SIDE;
        }
        return position;
    };
    PositionHandler.prototype.checkOutsideViewPortHeight = function (bouding, position) {
        if (bouding.top <= this.boxContainerRect.top + window.scrollY) {
            position.top = position.top + (this.boxContainerRect.top - position.top) + MARGIN_PARENT_SIDE;
        }
        if (bouding.bottom >= this.boxContainerRect.bottom + window.scrollY) {
            position.top = position.top - (bouding.bottom - this.boxContainerRect.bottom) - MARGIN_PARENT_SIDE;
        }
        return position;
    };
    PositionHandler.prototype.destroy = function () {
        clearTimeout(this.mouseEnterTimeout);
    };
    return PositionHandler;
}());
export { Position as P, UuidService as U, PositionHandler as a };
